/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ActionStatus = "Completed" | "NA" | "Open" | "Removed" | "%future added value";
export type BarrierStatus = "Open" | "Resolved" | "%future added value";
export type MilestoneStatus = "Completed" | "NA" | "Open" | "Removed" | "%future added value";
export type ProgressionIndicator = "AtRisk" | "HighRisk" | "NotSet" | "OnTime" | "%future added value";
export type Track = "Discharge" | "Progression" | "%future added value";
export type plan_removePlanTemplate_MutationVariables = {|
  planId: any,
  templateId: any,
|};
export type plan_removePlanTemplate_MutationResponse = {|
  +planMutation: ?{|
    +removePlanTemplate: ?{|
      +id: string,
      +appliedTemplates: ?$ReadOnlyArray<?{|
        +id: string,
        +name: string,
        +description: string,
        +documentURL: ?string,
        +removed: boolean,
      |}>,
      +careTeamMembers: $ReadOnlyArray<?{|
        +id: string,
        +name: ?string,
        +primary: ?boolean,
        +role: {|
          +id: string,
          +code: ?string,
          +value: ?string,
        |},
      |}>,
      +progressionIndicator: ProgressionIndicator,
      +toBeAdmitted: ?boolean,
      +meta: ?{|
        +milestoneMeta: {|
          +onTime: any,
          +overdue: any,
          +completed: any,
        |},
        +lengthOfStayMeta: {|
          +forecast: ?any,
          +cappedForecast: ?any,
        |},
        +actualOE: ?number,
      |},
      +milestones: $ReadOnlyArray<?{|
        +id: string,
        +name: string,
        +description: ?string,
        +track: ?Track,
        +dueDate: ?any,
        +completedDate: ?any,
        +status: MilestoneStatus,
        +planTemplateName: string,
        +actions: $ReadOnlyArray<?{|
          +id: string,
          +text: string,
          +status: ActionStatus,
          +pinned: boolean,
          +auditMeta: ?{|
            +created: any,
            +createdBy: {|
              +userName: string,
              +firstName: string,
              +lastName: string,
            |},
            +updated: any,
            +updatedBy: {|
              +userName: string,
              +firstName: string,
              +lastName: string,
            |},
          |},
          +milestoneTemplateName: ?string,
        |}>,
      |}>,
      +barriers: $ReadOnlyArray<?{|
        +id: string,
        +name: string,
        +description: string,
        +status: BarrierStatus,
        +pinned: boolean,
        +auditMeta: ?{|
          +created: any,
          +createdBy: {|
            +userName: string,
            +firstName: string,
            +lastName: string,
          |},
          +updated: any,
          +updatedBy: {|
            +userName: string,
            +firstName: string,
            +lastName: string,
          |},
        |},
        +category: {|
          +code: string,
          +value: string,
        |},
        +escalation: ?{|
          +auditMeta: ?{|
            +created: any,
            +createdBy: {|
              +userName: string,
              +firstName: string,
              +lastName: string,
            |},
          |}
        |},
        +owner: ?string,
        +ownerRole: ?{|
          +code: ?string,
          +value: ?string,
        |},
        +notes: ?$ReadOnlyArray<?{|
          +id: string,
          +text: string,
          +auditMeta: ?{|
            +created: any,
            +createdBy: {|
              +userName: string,
              +firstName: string,
              +lastName: string,
            |},
            +updated: any,
            +updatedBy: {|
              +userName: string,
              +firstName: string,
              +lastName: string,
            |},
          |},
          +pinned: boolean,
        |}>,
      |}>,
      +actions: $ReadOnlyArray<?{|
        +id: string,
        +text: string,
        +status: ActionStatus,
        +pinned: boolean,
        +auditMeta: ?{|
          +created: any,
          +createdBy: {|
            +userName: string,
            +firstName: string,
            +lastName: string,
          |},
          +updated: any,
          +updatedBy: {|
            +userName: string,
            +firstName: string,
            +lastName: string,
          |},
        |},
      |}>,
      +notes: $ReadOnlyArray<?{|
        +id: string,
        +text: string,
        +auditMeta: ?{|
          +created: any,
          +createdBy: {|
            +userName: string,
            +firstName: string,
            +lastName: string,
          |},
          +updated: any,
          +updatedBy: {|
            +userName: string,
            +firstName: string,
            +lastName: string,
          |},
        |},
        +pinned: boolean,
      |}>,
    |}
  |}
|};
export type plan_removePlanTemplate_Mutation = {|
  variables: plan_removePlanTemplate_MutationVariables,
  response: plan_removePlanTemplate_MutationResponse,
|};
*/


/*
mutation plan_removePlanTemplate_Mutation(
  $planId: UUID!
  $templateId: UUID!
) {
  planMutation {
    removePlanTemplate(planId: $planId, templateId: $templateId) {
      id
      appliedTemplates {
        id
        name
        description
        documentURL
        removed
      }
      careTeamMembers {
        id
        name
        primary
        role {
          id
          code
          value
        }
      }
      progressionIndicator
      toBeAdmitted
      meta {
        milestoneMeta {
          onTime
          overdue
          completed
        }
        lengthOfStayMeta {
          forecast
          cappedForecast
        }
        actualOE
      }
      milestones {
        id
        name
        description
        track
        dueDate
        completedDate
        status
        planTemplateName
        actions {
          id
          text
          status
          pinned
          auditMeta {
            created
            createdBy {
              userName
              firstName
              lastName
              id
            }
            updated
            updatedBy {
              userName
              firstName
              lastName
              id
            }
          }
          milestoneTemplateName
        }
      }
      barriers {
        id
        name
        description
        status
        pinned
        auditMeta {
          created
          createdBy {
            userName
            firstName
            lastName
            id
          }
          updated
          updatedBy {
            userName
            firstName
            lastName
            id
          }
        }
        category {
          code
          value
          id
        }
        escalation {
          auditMeta {
            created
            createdBy {
              userName
              firstName
              lastName
              id
            }
          }
          id
        }
        owner
        ownerRole {
          code
          value
          id
        }
        notes {
          id
          text
          auditMeta {
            created
            createdBy {
              userName
              firstName
              lastName
              id
            }
            updated
            updatedBy {
              userName
              firstName
              lastName
              id
            }
          }
          pinned
        }
      }
      actions {
        id
        text
        status
        pinned
        auditMeta {
          created
          createdBy {
            userName
            firstName
            lastName
            id
          }
          updated
          updatedBy {
            userName
            firstName
            lastName
            id
          }
        }
      }
      notes {
        id
        text
        auditMeta {
          created
          createdBy {
            userName
            firstName
            lastName
            id
          }
          updated
          updatedBy {
            userName
            firstName
            lastName
            id
          }
        }
        pinned
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "planId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "planId",
    "variableName": "planId"
  },
  {
    "kind": "Variable",
    "name": "templateId",
    "variableName": "templateId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "TemplateInfo",
  "kind": "LinkedField",
  "name": "appliedTemplates",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "removed",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "CareTeamMember",
  "kind": "LinkedField",
  "name": "careTeamMembers",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CodeTablePair",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progressionIndicator",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "toBeAdmitted",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "PlanMeta",
  "kind": "LinkedField",
  "name": "meta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MilestoneMeta",
      "kind": "LinkedField",
      "name": "milestoneMeta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "onTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "overdue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "completed",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LengthOfStayMeta",
      "kind": "LinkedField",
      "name": "lengthOfStayMeta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forecast",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cappedForecast",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualOE",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "track",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueDate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedDate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "planTemplateName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pinned",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v23 = [
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updated",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditMeta",
  "kind": "LinkedField",
  "name": "auditMeta",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditUser",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": (v23/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "milestoneTemplateName",
  "storageKey": null
},
v28 = [
  (v6/*: any*/),
  (v7/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "owner",
  "storageKey": null
},
v30 = [
  (v2/*: any*/),
  (v17/*: any*/),
  (v26/*: any*/),
  (v18/*: any*/)
],
v31 = [
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/),
  (v2/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditUser",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": (v31/*: any*/),
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "AuditMeta",
  "kind": "LinkedField",
  "name": "auditMeta",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v32/*: any*/),
    (v25/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AuditUser",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": (v31/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = [
  (v6/*: any*/),
  (v7/*: any*/),
  (v2/*: any*/)
],
v35 = [
  (v2/*: any*/),
  (v17/*: any*/),
  (v33/*: any*/),
  (v18/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "plan_removePlanTemplate_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlanMutation",
        "kind": "LinkedField",
        "name": "planMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "removePlanTemplate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Milestone",
                "kind": "LinkedField",
                "name": "milestones",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MilestoneAction",
                    "kind": "LinkedField",
                    "name": "actions",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v17/*: any*/),
                      (v15/*: any*/),
                      (v18/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Barrier",
                "kind": "LinkedField",
                "name": "barriers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v15/*: any*/),
                  (v18/*: any*/),
                  (v26/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BarrierCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": (v28/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Escalation",
                    "kind": "LinkedField",
                    "name": "escalation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuditMeta",
                        "kind": "LinkedField",
                        "name": "auditMeta",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v24/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CodeTablePair",
                    "kind": "LinkedField",
                    "name": "ownerRole",
                    "plural": false,
                    "selections": (v28/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BarrierNote",
                    "kind": "LinkedField",
                    "name": "notes",
                    "plural": true,
                    "selections": (v30/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PlanAction",
                "kind": "LinkedField",
                "name": "actions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v17/*: any*/),
                  (v15/*: any*/),
                  (v18/*: any*/),
                  (v26/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PlanNote",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": (v30/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "plan_removePlanTemplate_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlanMutation",
        "kind": "LinkedField",
        "name": "planMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "removePlanTemplate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Milestone",
                "kind": "LinkedField",
                "name": "milestones",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MilestoneAction",
                    "kind": "LinkedField",
                    "name": "actions",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v17/*: any*/),
                      (v15/*: any*/),
                      (v18/*: any*/),
                      (v33/*: any*/),
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Barrier",
                "kind": "LinkedField",
                "name": "barriers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v15/*: any*/),
                  (v18/*: any*/),
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BarrierCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": (v34/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Escalation",
                    "kind": "LinkedField",
                    "name": "escalation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuditMeta",
                        "kind": "LinkedField",
                        "name": "auditMeta",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v32/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CodeTablePair",
                    "kind": "LinkedField",
                    "name": "ownerRole",
                    "plural": false,
                    "selections": (v34/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BarrierNote",
                    "kind": "LinkedField",
                    "name": "notes",
                    "plural": true,
                    "selections": (v35/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PlanAction",
                "kind": "LinkedField",
                "name": "actions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v17/*: any*/),
                  (v15/*: any*/),
                  (v18/*: any*/),
                  (v33/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PlanNote",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": (v35/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "460b2f05fb1455f57d8bcafebe139b60",
    "id": null,
    "metadata": {},
    "name": "plan_removePlanTemplate_Mutation",
    "operationKind": "mutation",
    "text": "mutation plan_removePlanTemplate_Mutation(\n  $planId: UUID!\n  $templateId: UUID!\n) {\n  planMutation {\n    removePlanTemplate(planId: $planId, templateId: $templateId) {\n      id\n      appliedTemplates {\n        id\n        name\n        description\n        documentURL\n        removed\n      }\n      careTeamMembers {\n        id\n        name\n        primary\n        role {\n          id\n          code\n          value\n        }\n      }\n      progressionIndicator\n      toBeAdmitted\n      meta {\n        milestoneMeta {\n          onTime\n          overdue\n          completed\n        }\n        lengthOfStayMeta {\n          forecast\n          cappedForecast\n        }\n        actualOE\n      }\n      milestones {\n        id\n        name\n        description\n        track\n        dueDate\n        completedDate\n        status\n        planTemplateName\n        actions {\n          id\n          text\n          status\n          pinned\n          auditMeta {\n            created\n            createdBy {\n              userName\n              firstName\n              lastName\n              id\n            }\n            updated\n            updatedBy {\n              userName\n              firstName\n              lastName\n              id\n            }\n          }\n          milestoneTemplateName\n        }\n      }\n      barriers {\n        id\n        name\n        description\n        status\n        pinned\n        auditMeta {\n          created\n          createdBy {\n            userName\n            firstName\n            lastName\n            id\n          }\n          updated\n          updatedBy {\n            userName\n            firstName\n            lastName\n            id\n          }\n        }\n        category {\n          code\n          value\n          id\n        }\n        escalation {\n          auditMeta {\n            created\n            createdBy {\n              userName\n              firstName\n              lastName\n              id\n            }\n          }\n          id\n        }\n        owner\n        ownerRole {\n          code\n          value\n          id\n        }\n        notes {\n          id\n          text\n          auditMeta {\n            created\n            createdBy {\n              userName\n              firstName\n              lastName\n              id\n            }\n            updated\n            updatedBy {\n              userName\n              firstName\n              lastName\n              id\n            }\n          }\n          pinned\n        }\n      }\n      actions {\n        id\n        text\n        status\n        pinned\n        auditMeta {\n          created\n          createdBy {\n            userName\n            firstName\n            lastName\n            id\n          }\n          updated\n          updatedBy {\n            userName\n            firstName\n            lastName\n            id\n          }\n        }\n      }\n      notes {\n        id\n        text\n        auditMeta {\n          created\n          createdBy {\n            userName\n            firstName\n            lastName\n            id\n          }\n          updated\n          updatedBy {\n            userName\n            firstName\n            lastName\n            id\n          }\n        }\n        pinned\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ddb1a97e0980347e76a2035bc3472538';

module.exports = node;
